import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {NotificationService} from '../../utils/notification.service';

import { SessionSetting, Resources } from '../../../app.service';
import { KeycloakService } from '../../../keycloak.service';

declare var $: any;

declare var config: any;

@Component({
  selector: 'sa-logout',
  template: `
<div id="logout" (click)="showPopup()" class="btn-header transparent pull-right">
        <span> <a routerlink="/auth/login" title="Sign Out" data-action="userLogout"
                  data-logout-msg="You can improve your security further after logging out by closing this opened browser"><i
          class="fa fa-sign-out"></i></a> </span>
    </div>
  `,
  styles: []
})
export class LogoutComponent implements OnInit {

  constructor(private router: Router,
              private notificationService: NotificationService,
              private kc: KeycloakService) { }

  showPopup() {
    this.notificationService.smartMessageBox({
      title : '<i class="fa fa-sign-out txt-color-orangeDark"></i> ' +
              config.title + '<span class="txt-color-orangeDark"><strong>' + $('#show-shortcut').text() + '</strong></span>',
      content : Resources.getMessage('main.logout.ask'),
      buttons : '[' + Resources.getLabel('Cancel') + '][OK]'

    }, (ButtonPressed) => {
      if (ButtonPressed === 'OK') {
        this.logout()
      }
    });
  }

  logout() {
      // www this.router.navigate(['/auth/login'])
      SessionSetting.setUser(null);
      if (config.devMode) {
        //this.router.navigate(['login']);
        location.href = '/';
      } else {
        this.kc.logout();
      }
      //window.location.href = window.location.protocol + '//' + window.location.host;
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/user/logout/logout.component.ts